<template>
    <div class="page-container">
        <div class="fixed-header">
            <!-- <Content /> -->
            <div class="content-top">
                <div class="const-a">
                    <div class="content-top-left">
                        <img src="../assets/images/ap-1.png" alt="" @click="goToHome">
                    </div>
                    <!-- 顶部标题 -->
                    <div class="content-top-right">
                        <div class="text-a knowledge-points-title" :class="{ active: currentSubject === 'calculus' }"
                            @click="goToCalculusBC">
                            Calculus BC</div>
                        <div class="text-a" :class="{ active: currentSubject === 'microeconomics' }"
                            @click="goToMicroeconomics">Microeconomics</div>
                        <div class="text-a" :class="{ active: currentSubject === 'macroeconomics' }"
                            @click="goToMacroeconomics">Macroeconomics</div>
                        <div class="text-a" :class="{ active: currentSubject === 'physics' }" @click="goToPhysics1">
                            Physics1</div>
                        <div class="text-a" :class="{ active: currentSubject === 'biology' }" @click="goToBiology">
                            Biology</div>
                        <div class="text-a" :class="{ active: currentSubject === 'csp' }" @click="goToCSP">CSP</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="scrollable-content centered-content">
            <!-- <Content /> -->
            <div class="nav-container">
                <div class="nav-m">
                    <div class="text">
                        Practice with real AP questions - download anywhere and anytime!
                        <br>
                        Grab past AP papers and step-by-step solutions - quick and easy-to-access videos and notes!
                    </div>

                    <div class="boxes-container">
                        <div class="box-row-k">
                            <div v-for="(item, index) in 6" :key="item" class="box1-wrapper">
                                <div class="box1" :style="{ backgroundColor: boxColorList[index] }">
                                    <img :src="subjectList[index].image" alt="">
                                </div>
                                <div class="box1-a">
                                    <div class="text-1-n">{{ subjectList[index].name }}</div>
                                    <div class="box1-a-a">

                                        <div class="text-2" :style="{ backgroundColor: boxColorList2[index] }"
                                            @click="goToSubject(subjectList[index].path, subjectList[index].subject)">{{
                                                subjectList[index].buttonText

                                            }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <Concat /> -->
        </div>
        <div class="fixed-footer">
            <Concat />
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import Concat from '../components/Concat.vue'

// 导入图片资源
import p1Image from '../assets/images/p-1.png'
import p2Image from '../assets/images/p-2.png'
import p3Image from '../assets/images/p-3.png'
import p4Image from '../assets/images/p-4.png'
import p5Image from '../assets/images/p-5.png'
import p6Image from '../assets/images/p-6.png'


const router = useRouter()







const boxColorList = [
    '#D8E2FA',
    '#FDF4D9',
    '#FAE3DB',
    '#DAF4D5',
    '#FFEAF5',
    '#DFF4FF'
]
const boxColorList2 = [
    '#3676FF',
    '#FF9500',
    '#F6621F',
    '#55BA54',
    '#FB585B',
    '#40A4D8'
]

// 定义科目列表，包括名称、路由路径和按钮文本
const subjectList = [
    { 
        name: 'Calculus BC', 
        path: '/calculusbc', 
        subject: 'calculus', 
        buttonText: 'ClickView',
        image: p6Image
    },
    { 
        name: 'Microeconomics', 
        path: '/calculusbc', 
        subject: 'microeconomics', 
        buttonText: 'ClickView',
        image: p5Image
    },
    { 
        name: 'Macroeconomics', 
        path: '/calculusbc', 
        subject: 'macroeconomics', 
        buttonText: 'ClickView',
        image: p4Image
    },
    { 
        name: 'Physics1', 
        path: '/calculusbc', 
        subject: 'physics', 
        buttonText: 'ClickView',
        image: p3Image
    },
    { 
        name: 'Biology', 
        path: '/calculusbc', 
        subject: 'biology', 
        buttonText: 'ClickView',
        image: p2Image
    },
    { 
        name: 'CSP', 
        path: '/calculusbc', 
        subject: 'csp', 
        buttonText: 'ClickView',
        image: p1Image
    }
]

// 通用跳转函数，根据传入的路径跳转到对应页面
const goToSubject = (path, subject) => {
    router.push({
        path: path,
        query: { subject: subject }
    })
}

// 页面导航函数
const goToHome = () => {
    router.push('/')
}

const goToMicroeconomics = () => {
    router.push({
        path: '/calculusbc',
        query: { subject: 'microeconomics' }
    })
}

const goToBiology = () => {
    router.push({
        path: '/calculusbc',
        query: { subject: 'biology' }
    })
}

const goToPhysics1 = () => {
    router.push({
        path: '/calculusbc',
        query: { subject: 'physics' }
    })
}

const goToCSP = () => {
    router.push({
        path: '/calculusbc',
        query: { subject: 'csp' }
    })
}

const goToMacroeconomics = () => {
    router.push({
        path: '/calculusbc',
        query: { subject: 'macroeconomics' }
    })
}

const goToCalculusBC = () => {
    router.push({
        path: '/calculusbc',
        query: { subject: 'calculus' }
    })
}

</script>

<style scoped>
.knowledge-points-title {
    white-space: nowrap;
}
.fixed-header {
    /* flex-shrink: 0;  */
     background-color: black;
     width: 100vw;
}

.content-top {
    
    height: 100px;
    width: 100vw;
    background-color: black;
    height: 100px;
    padding: 0 120px;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.const-a {
   width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.content-top-left {
    width: 202px;
    height: 44px;
}

.content-top-left img {
    width: 202px;
    height: 44px;
    cursor: pointer;
}

.content-top-right {
    width: 890px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.text-a {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 22px;
    color: #FFFFFF;
    margin-right: 39px;
    cursor: pointer;
}

.text-a.active {
    text-decoration: underline;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    max-height: 1732px;
}

.fixed-footer {
    flex-shrink: 0;
}


@import '../pages/index.css'
</style>